var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationBingWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.79297V7.01297",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51327 1.83301C6.05993 1.83301 4.07327 3.81967 4.07327 6.27301V7.67301C4.07327 8.12634 3.8866 8.80634 3.65327 9.19301L2.8066 10.6063C2.2866 11.4797 2.6466 12.453 3.6066 12.773C6.79327 13.833 10.2399 13.833 13.4266 12.773C14.3266 12.473 14.7133 11.4197 14.2266 10.6063L13.3799 9.19301C13.1466 8.80634 12.9599 8.11967 12.9599 7.67301V6.27301C12.9533 3.83301 10.9533 1.83301 8.51327 1.83301Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7198 13.0469C10.7198 14.2669 9.71979 15.2669 8.49979 15.2669C7.89312 15.2669 7.33312 15.0135 6.93312 14.6135C6.53312 14.2135 6.27979 13.6535 6.27979 13.0469",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBingWhite);
export default __webpack_public_path__ + "static/media/notification-bing-white.f958822ed8edbcb9e80df59243dff4b2.svg";
export { ForwardRef as ReactComponent };